import { useTranslation } from '@frontend/i18n';
import { IconName } from '@frontend/icons';
import { WeaveRewindPrefixes } from '@frontend/tracking-prefixes';
import { theme } from '@frontend/theme';
import { Button, Modal, Text, useTooltip } from '@frontend/design-system';
import { translucentButtonStyles } from './styles';

const ButtonAtom = ({
  iconName,
  onClick,
  tooltipText,
  trackingId,
  ...rest
}: {
  iconName: IconName;
  onClick: () => void;
  tooltipText: string;
  trackingId: string;
  [key: string]: any;
}) => {
  const { Tooltip, tooltipProps, triggerProps } = useTooltip();

  return (
    <>
      <Button
        {...triggerProps}
        css={translucentButtonStyles}
        iconName={iconName}
        onClick={onClick}
        aria-label={tooltipText}
        trackingId={trackingId}
        {...rest}
      />
      <Tooltip {...tooltipProps}>{tooltipText}</Tooltip>
    </>
  );
};

type Props = {
  isMuted: boolean;
  onClose: () => void;
  onDownload: () => void;
  toggleMute: () => void;
};

export const ModalHeader = ({ isMuted, onClose, toggleMute }: Props) => {
  const { t } = useTranslation('dashboard');

  return (
    <Modal.Header>
      <Text color='white' weight='bold'>
        {t('2025 Weave Rewind')}
      </Text>
      <div css={{ display: 'flex', gap: 8 }}>
        <ButtonAtom
          css={
            isMuted && {
              background: theme.colors.neutral40,
              '&:hover, &:focus': {
                background: theme.colors.neutral40,
              },
            }
          }
          iconName='volume-mute-small'
          onClick={toggleMute}
          tooltipText={isMuted ? t('Unmute') : t('Mute')}
          trackingId={WeaveRewindPrefixes.Modal + '-header-mute-button'}
        />
        {/* TODO: re-add once the download functionality is set up */}
        {/* <ButtonAtom
                    iconName='download-small'
                    onClick={onDownload}
                    tooltipText={t('Download')}
                    trackingId={WeaveRewindPrefixes.Modal + '-header-download-button'}
                /> */}
        <ButtonAtom
          iconName='x-small'
          onClick={onClose}
          tooltipText={t('Close')}
          trackingId={WeaveRewindPrefixes.Modal + '-header-close-button'}
        />
      </div>
    </Modal.Header>
  );
};
